import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=63513ad4&scoped=true&"
import script from "./consult.vue?vue&type=script&lang=js&"
export * from "./consult.vue?vue&type=script&lang=js&"
import style0 from "./consult.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./consult.vue?vue&type=style&index=1&id=63513ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63513ad4",
  null
  
)

export default component.exports